module.exports = __webpack_public_path__ + "img/274466998_483674396747894_4840281090707913970_n.640de7dd.jpg";